import { createSelector } from 'reselect'

const oeqActivitySelector = state => state.creationTool.oeq

const oeqCancelSelector = createSelector(
	[oeqActivitySelector],
	oeq => ({
		isModified: oeq.isModified,
	})
)

export default oeqCancelSelector
